import { AppCardSkeleton } from '@app/components/base/app-card';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton placeholder matching EditCard layout: 16/9 media, title, action row.
 */
export function EditCardSkeleton() {
  return (
    <AppCardSkeleton
      footer={
        <Box
          sx={{
            px: 2,
            pb: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <Skeleton width={100} height={32} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
          </Box>
        </Box>
      }
    />
  );
}
